module.exports = __webpack_public_path__ + "static/rider-8c06d4131e52768b1d4e618f9dab3542.gif";